/* eslint-disable vue/attribute-hyphenation*/

<template>
  <div class="offerModule">
    <div v-if="loading"><Loader></Loader></div>
    <div v-if="!loading" class="offerModuleContainer">
      <div class="header"><img src="images/deputy-logo.svg" /></div>
      <div class="top-section">
        <h4 v-if="!schedule.Accepted">
          {{ schedule.Owner }} is offering their shift
        </h4>
        <h4 v-if="schedule.Accepted">
          {{ schedule.Owner }}'s shift is being covered
        </h4>
        <div class="shift-details">
          <DLayoutCard class="top-card">Shift Details</DLayoutCard>
          <DLayoutCard class="bottom-card">
            <b>Date:</b> {{ schedule.Date }} <br />
            <b>Location:</b> {{ schedule.Location }} <br />
            <b>Start - End time:</b> {{ schedule.Time }} <br />
          </DLayoutCard>
        </div>
        <div class="main-btn">
          <DSButton
            v-if="!schedule.Accepted"
            class="accept-btn"
            type="primary"
            :large="true"
            @click="showModal = true"
            >Accept</DSButton
          >
          <DSButton
            v-if="schedule.Accepted"
            class="accept-btn"
            :disabled="true"
            :large="true"
            >Accepted By {{ schedule.AcceptedBy }}</DSButton
          >
        </div>
      </div>
      <PlayStoreButton></PlayStoreButton>

      <AcceptModal
        v-if="showModal"
        :owner="schedule.Owner"
        @close="showModal = false"
        @submit="submitOffer"
      >
      </AcceptModal>

      <AcceptModal v-if="showModalError"
        ><template slot="header">
          {{ '' }}
        </template>
        <template slot="body">
          <h4>{{ errorMsg }}</h4>
        </template>
        <template slot="footer">
          <DSButton
            class="cancel"
            type="secondary"
            @click="showModalError = false"
            >Cancel</DSButton
          >
        </template>
      </AcceptModal>
    </div>
  </div>
</template>

<script>
import AcceptModal from '@/components/AcceptModal.vue';
import PlayStoreButton from '@/components/PlayStoreButton.vue';
import Loader from '@/components/Loader.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: { AcceptModal, Loader, PlayStoreButton },
  props: {
    userId: {
      type: String,
      required: true,
    },
    scheduleId: {
      type: String,
      required: true,
    },
    offerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      showModalError: false,
      loading: true,
      oId: this.offerId,
      errorMsg: '',
    };
  },
  computed: {
    ...mapState({
      schedule: state => state.Offer.schedule,
      error: state => state.Offer.error,
    }),
  },
  async created() {
    // offerId and jwt will be seperated by ';'
    const keys = this.offerId.split(';');
    this.oId = keys[0];
    this.loading = true;
    if (!keys[1]) {
      this.$router.push({
        name: 'HomeModule',
        params: { errMessage: 'Sorry failed to get token' },
      });
      throw new Error('missing temp JWT');
    }

    if (keys[1] || !this.session) {
      const jwtTempToken = keys[1];
      console.log('calling svc url:', jwtTempToken);
      try {
        const jwtToken = await this.$svcUrl.auth.token(jwtTempToken);
        console.log('new jwt: ', jwtToken);

        await this.$store.dispatch('setSession', {
          userId: this.userId,
          scheduleId: this.scheduleId,
          offerId: this.oId,
          jwt: jwtToken,
        });

        // this.$track('LandingPage');
        console.log('Url ids : ', this.userId, this.scheduleId, this.oId);
        await this.$store.dispatch('Offer/getSchedule', {
          userId: this.userId,
          scheduleId: this.scheduleId,
          offerId: this.oId,
        });

        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log('failed to get jwt', e);
        // redirect to home module
        this.$router.push({ name: 'HomeModule' });
        throw new Error('could not auth svc-url');
      }
    }
  },
  methods: {
    ...mapActions('Offer', ['getSchedule', 'postAccept']),
    submitOffer: async function(acceptName, accpetPhone) {
      this.loading = true;
      const data = {
        fullName: acceptName,
        mobile: accpetPhone,
      };
      // start loader
      try {
        await this.postAccept({
          userId: this.userId,
          scheduleId: this.scheduleId,
          offerId: this.oId,
          data,
        });

        this.loading = false;
      } catch (e) {
        this.loading = false;
        if (this.error.length && this.error[0].code === 412) {
          this.errorMsg =
            'Oops! This shift has been accepted while you were filling in your details.'; // this.error[0].message;
          this.showModalError = true;
          await this.getSchedule({
            userId: this.userId,
            scheduleId: this.scheduleId,
            offerId: this.oId,
          });
        } else {
          console.log('failed to post correctly', e);
          // redirect to home module
          this.$router.push({ name: 'HomeModule' });
          throw new Error('could not post to svc url');
        }
      }
    },
  },
};
</script>

<style scoped>
.offerModuleContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  max-width: 430px; /* keep mobile width */
}
.shift-details {
  padding: 1rem;
  font-size: 16px;
  line-height: 25px;
}
.header {
  width: 100%;
  padding: 1rem;
}
.header > img {
  display: flex;
  width: 15rem;
  margin: auto;
}
.top-section {
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  padding: 1rem;
}
.top-card {
  margin-bottom: 1px;
  color: gray;
}
.bottom-card {
  text-align: left;
}
.main-btn {
  padding: 10px;
}

.accept-btn {
  padding: 1rem;
  width: 100%;
}
</style>
